export const SLIDER_CONSTS = {
    GET_SLIDERS: "GET_SLIDERS",
    CREATE_SLIDER: "CREATE_SLIDER",
    UPDATE_SLIDERS_POSITIONS: "UPDATE_SLIDERS_POSITIONS",
    UPDATE_SLIDER_BY_ID: "UPDATE_SLIDER_BY_ID",
    DELETE_SLIDER_BY_ID: "DELETE_SLIDER_BY_ID",
    SET_SLIDER_TYPE:"SET_SLIDER_TYPE",
};
